import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth/auth.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Logging } from '../logging';
import { ApiService } from '../shared/api-service/api.service';
import { HelpersService } from '../shared/helpers/helpers.service';

declare var jquery:any;
declare var $ :any;
declare var App:any;

@Component({
  selector: 'app-login-otp',
  templateUrl: './login-otp.component.html',
  styleUrls: ['./login-otp.component.css']
})
export class LoginOtpComponent implements OnInit {

  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router,private helpers: HelpersService) {


}

loading: Boolean = false;
hasError: Boolean = false;
errorMessage: string ;
userDetails: any ;
showForceLogoutError:any = false;
loginDetails:any;
userName:any;
userId: number;
sendingOTP : Boolean = false;

  ngOnInit() {

    if(!this.auth.loginDetailsSet()){
      this.router.navigate(['/login']);
    }
    // this.helpers.flashSuccess('Contact Created Successfully');
    this.loginDetails = this.auth.getLoginDetails();
    this.userName = this.loginDetails.name;
    this.userId = this.loginDetails.userid;

    if(this.loginDetails.accountlocked == true &&
        this.loginDetails.emailvalidated == true &&
        this.loginDetails.phonevalidated == true){

      this.router.navigate(['/login/account-locked']);
      return true;
    }

    this.auth.forcelogout.subscribe((value) => {
      this.showForceLogoutError = value;

    });

    if(this.auth.isLoggedIn()){
      this.router.navigate(['/dashboard']);
    }


    //Navigate to dashboard after login success with this observable
    this.auth.token_set.subscribe((status) => {
      if(status == true){
        this.router.navigate(['/dashboard']);
      }
    });

    $( "input[name='otp']" ).focus();

  }


  verifyOtp(form: NgForm){

    var self = this;

    //Set loading to true to show loader
    this.loading = true;
    this.hasError = false;

    // Collect form values
    const values = form.value;

    var payload = {
      userid: this.loginDetails.userid,
      otp: values.otp,
    };

    // const staffBody = {
    //   email: "eani286@gmail.com",
    //   password: "Good4Redde@20",
    //   maccaddress: "E8:2A:EA:8B:D8:88"
    // }
    //Make the api request
    this.api.post('/users/validateloginotp', payload)
    .subscribe(
      res_data => {
      Logging.log(res_data);

      //Set the token for the current user.
      const userToken: string = res_data.data[0].accessToken.token;
      this.auth.setToken(userToken);

    //     this.api.post('users/adm/slogin', staffBody)
    //       .subscribe(
    //        res_data => {
    //        Logging.log(res_data.data[0].accessToken.token);

    //     //Set the token for the current user.
    //       const staffToken: string = res_data.data[0].accessToken.token;
    //       this.auth.setToken(staffToken)
    //   },
    //   error_message => {
    //     this.loading = false;
    //     this.hasError = true;
    //     this.errorMessage = error_message;
    //   }
    // )


      //Set the user into the local storage to prevent loss after hard rest
      this.auth.setUser(res_data.data[0].useraccount);

      var animationOut = "animated fadeOutLeft";
      var animationend = "wenkitAnimationEnd mozAnimationEnd MS AnimationEnd oanimationend animationend";

      //Show The next form depending on user data
      $('#credentials-verification')
        .addClass(animationOut)
        .one(animationend, function(){

          //Redirect if condition is met
          self.router.navigate(['/dashboard']);

        });

        this.loading = false;

      }, error_message => {
        this.loading = false;
        this.hasError = true;
        this.errorMessage = error_message;
      }
    );



  }


  resendOTP()
  {
    //Make the api request
    this.sendingOTP = true;

    this.api.get('/users/' + this.userId + '/sendloginotp')
    .subscribe(
      res_data => {
      Logging.log(res_data);

      this.sendingOTP = false;
      this.helpers.flashSuccess("New OTP has been sent to your phone");

      }, error_message => {
        this.sendingOTP = false;
        this.hasError = true;
        this.errorMessage = error_message;
      }
    );
  }

  clearErrors(){
    this.hasError = false;
    this.errorMessage ="";
  }
}



// WEBPACK FOOTER //
// ./src/app/login-otp/login-otp.component.ts